import axios from '../axios'

/*
 * 订单管理模块
 */

// 查询
export const selectByPage = (data) => {
    return axios({
        url: '/admin/rebateOrder/selectByPage',
        method: 'post',
        data
    })
}

// 订单配置
export const syncSelectByPage = (data) => {
    return axios({
        url: '/admin/syncTime/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/admin/syncTime/insert',
        method: 'post',
        data
    })
}

export const batchSettlement = (data) => {
    return axios({
        url: '/admin/rebateOrder/batchSettlement',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/rebateOrder.js